import { QueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

/**
 * Shared TanStack Query client.
 *
 * Defaults tuned for a medical data app: don't hammer the API on window focus,
 * keep data fresh for a minute, and never auto-retry auth failures (401/403/422)
 * — those are terminal and handled by the interceptor / form layer.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // MEDIS circuit-breaker is open → terminal, don't pile on retries.
        if ((error as { isMedisUnavailable?: boolean })?.isMedisUnavailable) return false;
        const status = error instanceof AxiosError ? error.response?.status : undefined;
        if (status && [401, 403, 404, 422].includes(status)) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
